import { useState } from "react";

interface ActionButtonHomeProps {
    title: string;
    icon: (active: boolean) => React.ReactNode;
    onClick: () => void;
}

export const ActionButtonHome = ({ title, icon, onClick }: ActionButtonHomeProps) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <button
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className="w-full shadow-sm flex items-center px-4 py-2 bg-white rounded-[12px] group transition-all duration-200 text-textButton hover:text-white hover:bg-gradient-to-r hover:from-[#5050EA] hover:to-[#85A2FF]"
        >
            <div className="p-3 rounded-lg group-hover:bg-transparent transition-colors duration-200">
                <div className="text-[#4D88FF] group-hover:text-white">
                    {icon(isHovered)}
                </div>
            </div>
            <span className="font-medium text-xl">{title}</span>
        </button>
    );
};
